import { Component, OnInit } from '@angular/core';
import { InventoryService } from '../../inventory/inventory.service';
import { LocationDto } from '../../inventory/inventory.model';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-reorder-requests',
  templateUrl: './reorder-requests.component.html',
  styleUrls: ['./reorder-requests.component.scss'],
  imports:[FormsModule]
})
export class ReorderRequestsComponent implements OnInit {
  reorderRequests: any[] = [];
  allLocations: LocationDto[] = [];
  selectedLocationId: string = '';

  constructor(private inventoryService: InventoryService) {}

  ngOnInit(): void {
    this.loadLocations();
    this.loadReorderRequests();
  }

  loadLocations(): void {
    this.inventoryService.getAllLocations().subscribe((res) => {
      this.allLocations = res.data;
    });
  }

  loadReorderRequests(): void {
    const locationId = this.selectedLocationId;
    this.inventoryService.getAllReorderRequests().subscribe((res) => {
      this.reorderRequests = res;
    });
  }

  onLocationChange(): void {
    this.loadReorderRequests();
  }
}
